import React, {PropTypes} from 'react';
import CustomListItem from '../../../../components/common/CustomList/CustomListItem'
import Avatar from 'material-ui/Avatar';
import IconEdit from '../../../Icons/IconEdit';
import IconButton from 'material-ui/IconButton';
import IconMove from '../../../Icons/IconMove';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

export class EngineerItem extends React.Component {
  static propTypes = {
    isDragging: PropTypes.bool,
    isOver: PropTypes.bool,
    editItem: PropTypes.func.isRequired,
    deleteItem: PropTypes.func.isRequired,
    color: PropTypes.object
  };

  render() {
    const {item, index, connectDragSource, connectDragPreview} = this.props;

    return (
      <div>
        {connectDragPreview(
          <div>
            <CustomListItem key={index}
                      primaryText={item.primaryText}
                      secondaryText={item.secondaryText}
                      leftItems={<Avatar src={item.avatar}/>}
                      rightItems={
                                <div style={{display: 'flex'}}>
                                  {connectDragSource(
                                    <span>
                                      <IconButton style={{cursor: 'move'}}>
                                        <IconMove color={this.props.color}/>
                                      </IconButton>
                                    </span>
                                  )}
                                  <IconButton
                                    onClick={() => {this.props.editItem(item);}}>
                                    <IconEdit color={this.props.color}/>
                                  </IconButton>
                                  <IconButton onClick={(event) => {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    this.props.deleteItem(item)
                                  }}>
                                    <DeleteIcon color={this.props.color}/>
                                  </IconButton>
                                </div>}/>
          </div>
        )}
      </div>
    );
  }
}

export default EngineerItem;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/DragItems/DraggableItem/EngineerItem.js